import { render, staticRenderFns } from "./OrderRecipientTab.vue?vue&type=template&id=78f9c0f0&scoped=true"
import script from "./OrderRecipientTab.vue?vue&type=script&lang=js"
export * from "./OrderRecipientTab.vue?vue&type=script&lang=js"
import style0 from "./OrderRecipientTab.vue?vue&type=style&index=0&id=78f9c0f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f9c0f0",
  null
  
)

export default component.exports